<template>
<div>
  <div class="title mt-5">
    <h3 class="d-flex justify-content-center header">
      {{$t('headers.hearing_test')}}
    </h3>
  </div>
  <div class="content">

    <fade-transition :duration="250" mode="out-in">

      <div key="1" v-if="!data.headphone">
        <div class="d-flex justify-content-center mb-1 mb-md-5">
          <span class="header header-2">{{$t('hearing_test_configuration.headphone_selection_header')}}</span>
        </div>
        <div class="d-flex flex-column align-items-center flex-md-row justify-content-md-around mt-1 mt-md-5">
          <div v-for="headphone in headphoneTypes" :key="headphone.id" class="headphones-selection" @click="selectHeadphones(headphone)">
            <img :src="`public/${headphone.image}`" alt="">
          </div>
        </div>
      </div>

      <div key="2" v-else>

        <div class="d-flex justify-content-center mb-3">
            <span class="header header-2">{{$t('hearing_test_configuration.personal_informations')}}</span>
        </div>

        <form novalidate class="form">
          <div class="form-row">
            <div class="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
              <select v-model="data.user.birthdate" class="form-control" id="selectage">
                <option :value="null" disabled selected>{{$t('form.age')}}</option>
                <option v-for="(ageGroup, index) in ageGroupOptions" :key="index" :value="ageGroup.value">{{ageGroup.label}}</option>
              </select>
            </div>
          </div>
          <!-- <div class="form-row">
            <div class="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2">
              <select v-model="data.user.gender" class="form-control" id="selectgender">
                <option :value="null" disabled selected>{{$t('form.gender.title')}}</option>
                <option v-for="(gender, index) in genderOptions" :key="index" :value="gender.value">{{gender.label}}</option>
              </select>
            </div>
          </div> -->
          <div class="form-row">
            <div class="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2 pl-2 pr-2">
              <label class="custom-label" for="age-group">{{$t('form.gender.title')}}</label>
              <div class="d-flex justify-content-between">
                <span class="checkbox__container" v-for="(gender, index) in genderOptions">
                  <span v-if="data.user.gender == gender.value"  @click="data.user.gender = gender.value" class="i-checkbox-selected"></span>
                  <span v-else @click="data.user.gender = gender.value" class="i-checkbox"></span>
                  <label class="checkbox__label" for="checkbox1">{{ gender.label }}</label>
                </span>
              </div>
            </div>
          </div>
        </form>

        <div class="d-flex justify-content-between mt-5">
          <button type="button" class="button secondary" @click="data.headphone = null">{{$t('actions.back')}}</button>
          <button type="button" class="button primary" :class="{'disabled': data.user.birthdate === null}" :disabled="data.user.birthdate === null" @click="saveInfo">{{$t('actions.start')}}</button>
        </div>

      </div>

    </fade-transition>
  </div>
</div>
</template>
<script>
import HeadphoneTypes from '@/HeadphoneTypes'
import FadeTransition from '@/vue-components/Utils/FadeTransition.vue'
export default {
  components: {
    FadeTransition
  },
  props: {
    user: {
      type: Object,
      required: false
    },
    headphone: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      data: {
        user: {
          name: null,
          email: null,
          phone: null,
          city: null,
          address_line_1: null,
          address_postal_code: null,
          address_city: null,
          birthdate: null,
          gender: null,
          contact_request: false,
          marketing: false
        },
        ht: null,
        headphone: null,
      },
      headphoneTypes: HeadphoneTypes,
      ageGroupOptions: [
        {
          id: 1,
          label: ' < 18',
          value: this.moment().subtract(15, 'years').format('YYYY-MM-DD')
        },
        {
          id: 2,
          label: '18-29',
          value: this.moment().subtract(20, 'years').format('YYYY-MM-DD')
        },
        {
          id: 3,
          label: '30-49',
          value: this.moment().subtract(40, 'years').format('YYYY-MM-DD')
        },
        {
          id: 4,
          label: '50-65',
          value: this.moment().subtract(60, 'years').format('YYYY-MM-DD')
        },
        {
          id: 5,
          label: '> 65',
          value: this.moment().subtract(70, 'years').format('YYYY-MM-DD')
        },
      ],
    }
  },
  mounted () {
    // this.data.user.birthdate = this.ageGroupOptions[3].value
    this.data.user.gender = this.genderOptions[0].value
  },
  computed: {
    genderOptions: function () {
      return [
        {
          id: 1,
          label: this.$t('form.gender.not_disclosed'),
          value: 'not_disclosed'
        },
        {
          id: 2,
          label: this.$t('form.gender.male'),
          value: 'male'
        },
        {
          id: 3,
          label: this.$t('form.gender.female'),
          value: 'female'
        }
      ]
    },
  },
  methods: {
    selectHeadphones: function (headphone) {
      this.data.headphone = headphone
    },
    saveInfo: function () {
      if (this.data.user.birthdate === null) return
      this.$emit('update:user', this.data.user)
      this.$emit('update:headphone', this.data.headphone)
      this.$emit('continue')
    }
  }
}
</script>
<style lang="scss" scoped>

.headphones-selection {
  width: 225px;
  height: 225px;
  opacity: 0.8;
  transition: 250ms ease-in;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.2);
  max-height: 25vh;
  max-width: 25vh;
}

.headphones-selection img{
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.headphones-selection:hover {
  opacity: 1;
  transform: scale(1.1);
}

@media only screen and (max-width: 768px) {
  .headphones-selection {
    margin-bottom: 2rem;
  }
}

.form select,
.form select:focus {
  background-color: transparent;
  border-radius: 5px;
  border-style: solid;
}

.i-checkbox {
  display: inline-block;
  width: 18px;
  min-width: 18px;
  height: 18px;
  background: url('../../../public/checkbox.svg') no-repeat center center;
  background-size: contain;
  cursor: pointer;
  margin-right: 5px;
}

.i-checkbox-selected {
  display: inline-block;
  width: 18px;
  min-width: 18px;
  height: 18px;
  background: url('../../../public/checkbox_selected.svg') no-repeat center center;
  background-size: contain;
  cursor: pointer;
  margin-right: 5px;
}

.checkbox__container {
  display: inline-flex;
  justify-content: start;
  align-items: center;
  margin-left: 0;

  & .i-checkbox,.i-checkbox-selected {
    margin-right: 0.8rem;
  }

  & input {
    margin-right: 1rem;
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }

  & .checkbox__label {
    color: #495057;;
    margin-bottom: 0;
  }
}

</style>